module.exports = __webpack_public_path__ + "media/salicylic-small.b3dcab72.mp4";